<template>
  <div class="container gallery">
    <h1>gallery</h1>
    <div class="pop-up" @click="popupClose()" v-if="popup">
      <div class="img-box">
        <img :src="require(`@/assets/${popupImg.img}`)" alt="" />
      </div>
    </div>
    <div class="row grid justify-content-center">
      <div class="col-md-4 col-sm-6" v-for="item in items" :key="item">
        <div class="gallery-box">
          <img :src="require(`@/assets/${item.img}`)" alt="Portolio" />
          <div class="overlay">
            <a @click="imgClick(item)"
              ><font-awesome-icon icon="fa-solid fa-eye"
            /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "GalleryPage",
  data() {
    return {
      popup: false,
      popupImg: "",
      items: [
        {
          img: "1.jpg",
        },
        {
          img: "2.jpg",
        },
        {
          img: "3.jpg",
        },
        {
          img: "4.jpg",
        },
        {
          img: "5.jpg",
        },
        {
          img: "6.jpg",
        },
        {
          img: "7.jpg",
        },
        {
          img: "8.jpg",
        },
        {
          img: "9.jpg",
        },
        {
          img: "10.jpg",
        },
        {
          img: "11.jpg",
        },
        {
          img: "Hmama.png",
        },
        {
          img: "zaoub.png",
        },
        {
          img: "easytrips.png",
        },
      ],
    };
  },
  methods: {
    imgClick(item) {
      this.popup = true;
      this.popupImg = item;
    },
    popupClose() {
      this.popup = false;
    },
  },
};
</script>
